<template>
  <UApp :locale="locales[locale]">
    <!-- NuxtPwaManifest -->
    <NuxtLoadingIndicator />
    <NuxtLayout>
      <NuxtPage />
      <!-- ClientOnly><AutoUpdate /></ClientOnly -->
    </NuxtLayout>
  </UApp>
</template>

<script setup lang="ts">
  import * as locales from '@nuxt/ui/locale'

  const { locale } = useI18n()
</script>